exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n\r\n.has-error{\r\n      padding: 0;\r\n    font-size: 14px;\r\n}\r\n ", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/deliverproject/eatasiafood/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main